


































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
    ComponentMobileImageGallery2: () =>
      import('~/components/mobile/images/m-gallery-2.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
  },
})
export default class ComponentMobileReviewsPhotos extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: IImageVariants[]

  private $style!: IStyle
  private isComponentMobileImageGallery2Loaded = false
  private isShowComponentMobileImageGallery2 = false
  private photoStartNum = 0
  private ShowGallery(num: number) {
    this.photoStartNum = num
    this.isShowComponentMobileImageGallery2 = true
  }
}
